import React, { createContext, useContext } from 'react'
import Checkbox from '@material-ui/core/Checkbox'

import { isSelected } from 'Utils/CityPlan'

/**
 * The page's selection, readable from inside table rows.
 *
 * DataFetchingComponent keeps the rendered rows in its own state and only
 * rebuilds them on a fetch, so a checkbox baked into a row would never
 * reflect a click. These checkboxes subscribe to the selection instead and
 * re-render on their own.
 */
const SelectionContext = createContext({
  selection: { mode: 'ids', ids: new Set() },
  onToggle: () => {},
})

export const SelectionProvider = SelectionContext.Provider

export const SelectionCheckbox = ({ id }) => {
  const { selection, onToggle } = useContext(SelectionContext)
  return (
    <Checkbox
      checked={isSelected(selection, id)}
      onChange={() => onToggle(id)}
      size="small"
      inputProps={{ 'aria-label': `Select mission ${id}` }}
    />
  )
}

export default SelectionContext
